import { BannerNotification } from '@services/notification.service/bar_notification';
import { NotificationService } from '@services/notification.service/mod';
import { useService } from '@visiba/instantiation';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { InformationBanner } from './_banner_notification_information_banner.component';

interface Props {}

const elements = {
	container: styled(motion.div)`
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		z-index: 2;
		display: flex;
		flex-direction: column;
	`,
	element: styled(motion.div)`
		width: 100%;
	`,
};

export function BannerNotifications(_: Props): JSX.Element {
	const notificationService = useService(NotificationService);
	const [notifications, setNotifications] = useState<BannerNotification[]>([]);

	useEffect(() => {
		function handleChange(_: BannerNotification): void {
			setNotifications([...(notificationService.get('banner') as any)]);
		}

		notificationService.eventEmitter.on('onAddBanner', handleChange);
		notificationService.eventEmitter.on('onRemoveBanner', handleChange);

		return () => {
			notificationService.eventEmitter.off('onAddBanner', handleChange);
			notificationService.eventEmitter.off('onRemoveBanner', handleChange);
		};
	}, [notificationService]);

	function handleRemoveClick(target: BannerNotification): void {
		notificationService.remove(target);
		setNotifications([...(notificationService.get('banner') as any)]);
	}

	return (
		<elements.container>
			<AnimatePresence initial={false}>
				{notifications.map((notification) => {
					return (
						<elements.element
							layout
							key={notification.guid}
							initial={{ opacity: 0 }}
							animate={{ opacity: 1, transition: { duration: 0.25 } }}
							exit={{ opacity: 0, transition: { duration: 0.25 } }}
						>
							{notification.type === 'information' && (
								<InformationBanner
									Component={notification.ui}
									removeFn={() => {
										handleRemoveClick(notification);
									}}
								/>
							)}
						</elements.element>
					);
				})}
			</AnimatePresence>
		</elements.container>
	);
}
